import React from 'react';
import PropTypes from 'prop-types';
import Header from './Global/Header/Header';
import Notifications from './Global/Notifications/Notifications';

const App = props => (
  <div className="app-child-routes">
    <Header location={props.location} loggedInUser={props.loggedInUser} />
    {props.children}
    <Notifications />
  </div>
);

App.propTypes = {
  location: PropTypes.object.isRequired,
  loggedInUser: PropTypes.object,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
};

export default App;



// WEBPACK FOOTER //
// ./library/app/components/App.js